import { Message } from '@aperza/ui';
import { AppService } from '@aperza/util';
import { faBookOpen, faNewspaper, faShoppingCart, faUsersClass, faVideo, } from '@fortawesome/pro-regular-svg-icons';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import NavBarItem from './NavBarItem';
import PromoteCompanyLink from './PromoteCompanyLink';
import SignUpLink from './SignUpLink';
const appConfig = AppService.appConfig();
const NavBar = (props) => {
    const { viewer, disableNavCatalog, disableNavMarketplace, disableNavNews, disableNavExhibitions, disableNavManufacturers, disableNavShops, disableNavPromote, disableNavRegisterAccount, disableAperzaTv, } = props;
    const style = {
    // position: 'absolute',
    // left: this.state.left,
    };
    const refParent = useRef(null);
    const ref = useRef(null);
    const [left, setLeft] = useState(0);
    return (React.createElement("div", { ref: refParent, className: "strip aw-navbar", style: {
            justifyContent: 'space-between',
            position: 'relative',
            height: '18px',
        } },
        React.createElement("div", { ref: ref, className: "strip", style: style },
            !disableNavCatalog && (React.createElement(React.Fragment, null,
                React.createElement(NavBarItem, { title: React.createElement(Message, { messageId: "navbar.searchCatalog" }), shortTitle: React.createElement(Message, { messageId: "navbar.searchCatalog_short" }), icon: { icon: faBookOpen, size: 'lg' }, url: `${appConfig.searchWebUrlPrefix}/catalog/` }))),
            !disableNavMarketplace && (React.createElement(React.Fragment, null,
                React.createElement(NavBarItem, { title: React.createElement(Message, { messageId: "navbar.buy" }), shortTitle: React.createElement(Message, { messageId: "navbar.buy_short" }), icon: { icon: faShoppingCart, size: 'lg' }, url: `https://www${appConfig.baseComDomain}/marketplace/index.html` }))),
            !disableNavNews && (React.createElement(React.Fragment, null,
                React.createElement(NavBarItem, { title: React.createElement(Message, { messageId: "navbar.news" }), shortTitle: React.createElement(Message, { messageId: "navbar.news_short" }), icon: { icon: faNewspaper, size: 'lg' }, openOnNewTab: true, url: `https://news${appConfig.baseDomain}` }))),
            !disableNavExhibitions && (React.createElement(React.Fragment, null,
                React.createElement(NavBarItem, { title: React.createElement(Message, { messageId: "navbar.exhibitions" }), shortTitle: React.createElement(Message, { messageId: "navbar.exhibitions_short" }), icon: { icon: faUsersClass, size: 'lg' }, url: `${appConfig.searchWebUrlPrefix}/feature/top` }))),
            !disableNavManufacturers && (React.createElement(React.Fragment, null,
                React.createElement(NavBarItem, { title: React.createElement(Message, { messageId: "navbar.ec.manufacturers" }), url: `${appConfig.marketplaceWebUrlPrefix}/mfr/index.html` }))),
            !disableNavShops && (React.createElement(React.Fragment, null,
                React.createElement(NavBarItem, { title: React.createElement(Message, { messageId: "navbar.ec.shops" }), url: `${appConfig.searchWebUrlPrefix}/dst/mp/index.html` }))),
            !disableAperzaTv && (React.createElement(React.Fragment, null,
                React.createElement(NavBarItem, { title: React.createElement(Message, { messageId: "navbar.aperzaTv" }), icon: { icon: faVideo, size: 'lg' }, url: `${appConfig.aperzaTvHost}` })))),
        React.createElement("div", { className: "strip right " },
            !disableNavPromote && viewer && !viewer.isLogin && (React.createElement(React.Fragment, null,
                React.createElement(PromoteCompanyLink, { ...props }))),
            !disableNavRegisterAccount && viewer && !viewer.isLogin && (React.createElement(React.Fragment, null,
                React.createElement(SignUpLink, { ...props }))),
            !disableNavPromote &&
                viewer &&
                viewer.isLogin &&
                [1, 2, 3].includes(viewer.endUserType) && React.createElement(PromoteCompanyLink, null))));
};
NavBar.propTypes = {
    viewer: PropTypes.shape({
        id: PropTypes.string,
        isLogin: PropTypes.bool,
        endUserType: PropTypes.number,
    }),
    disableNavCatalog: PropTypes.bool,
    disableNavMarketplace: PropTypes.bool,
    disableNavNews: PropTypes.bool,
    disableNavExhibitions: PropTypes.bool,
    disableNavManufacturers: PropTypes.bool,
    disableNavShops: PropTypes.bool,
    disableNavPromote: PropTypes.bool,
    disableNavRegisterAccount: PropTypes.bool,
    disableMarketplaceBanner: PropTypes.bool,
};
NavBar.fragments = {
    viewer: gql `
    fragment NavBar_viewer on Viewer {
      id
      isLogin
      endUserType
    }
  `,
};
export default NavBar;
